<template lang="pug">
  #information-list(v-cloak)
    .box
      .box-header.with-border.register-header
        .title
          span {{ notification.title }}
        .buttons
          button.btn.back-btn(@click="gotoNotificationList()" type="button") 戻る
      .box-body
        .notification-date.text-right.mb-2 {{ getDate(notification) }}
        .notification-body(v-html="notification.text")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { notificationStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";

import { Url } from "@/commons/constants/Url";
import { PcUrl } from "@/commons/constants/PcUrl";
import { Account } from "@/commons/services/Authorization";
import NotificationsService, { NotificationsGetModel } from "@/commons/services/Notifications";

/**
 * お知らせ画面詳細コンポーネント
 */
@Component
export default class NotificationDetail extends Vue {
  /** お知らせサービス */
  @Inject("NotificationsService") notificationsService!: NotificationsService;

  /** お知らせ */
  notification: NotificationsGetModel | null = null;

  /**
   * vue lifecycle created
   */
  public created(): void {
    // 画面表示用にstoreからお知らせを取得する
    // 存在しない場合は404 NotFoundとして扱う
    const notification: NotificationsGetModel = notificationStore.notification;

    if (!notification) {
      this.$router.push(Url.NotFound);
      return;
    }

    this.notification = notification;

    // バックグラウンドでお知らせを既読にする
    this.confirmNotification();

    return;
  }

  /**
   * お知らせを既読にする
   */
  public async confirmNotification(): Promise<void> {
    try {
      // 既読にする必要がないお知らせの場合も何もしない
      if (this.notification == null || !this.notification.required) {
        return;
      }

      // 不要なリクエストを避けるためにログイン時に取得した既読お知らせリストと照合する
      // 既読であれば何もしない
      let loginUser: Account = userStore.loginUser;
      if (0 <= loginUser.confirmedNotificationIds.indexOf(this.notification.id)) {
        return;
      }

      // お知らせを読んだことをAPIに通知し、現在のログイン情報の既読お知らせリストも更新する
      await this.notificationsService.patch(userStore, this.notification.id, userStore.loginUser.userId);
      loginUser.confirmedNotificationIds.push(this.notification.id);

      // ヘッダーメニューの未読バッジを更新する
      this.$emit("refresh");
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }

    return;
  }

  /**
   * お知らせ一覧画面へ遷移する
   */
  public gotoNotificationList(): void {
    this.$router.push(PcUrl.NotificationList);

    return;
  }

  /**
   * 日付(yyyy年mm月dd日)を返す
   */
  public getDate(notification: NotificationsGetModel | null): string {
    if (!notification || !notification.startPublish || Number.isNaN(notification.startPublish)) {
      return "";
    }
    return this.$dateUtil.convertNumberToString(notification.startPublish, "yyyy年mm月dd日", false);
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

// 親要素からネストしてスタイルを指定する
#information-list {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
}
</style>
